module.exports = __webpack_public_path__ + "img/order8.67ea68f0.png";